<template>
  <div class="padding-five-lr " style="background: #f8f8f8">
    <div>
      <b-row style="max-width: 100%">
        <b-col xs="12" sm="12" md="12" lg="4" class="padding-ten-tb">
          <h5 class="color-gray">Administración de OS</h5>
        </b-col>
      </b-row>
      <b-row style="max-width: 100%">
        <b-col xs="12" sm="12" md="12" lg="4">
          <h5 class="color-orange">Búsqueda</h5>
        </b-col>
      </b-row>
    </div>
    <div class="bg-white padding-five-all">
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="4" class="my-1">
            <b-form-group label="TIPO OS" label-for="input-select1">
              <b-form-select
                id="input-select1"
                v-model="selectedTypeOs"
                size="md"
                :options="optionsTypeOs"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="4" class="my-1">
            <b-form-group label="Tipo de documento" label-for="input-select">
              <b-form-select
                id="input-select"
                @change="clearParamsVal"
                v-model="selectedValue"
                size="md"
                :options="optionsTypeDoc"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="4" class="my-1">
            <b-form-group
              label="Número de documento"
              label-for="input-doc"
              v-if="selectedValue == 'a'"
            >
              <b-form-input
                id="input-doc"
                type="text"
                v-model.trim="valueParams.dni"
                size="md"
                class="placeholder-black"
                placeholder="Ingrese el valor"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="N.V"
              label-for="input-nv"
              v-else-if="selectedValue == 'b'"
            >
              <b-form-input
                id="input-nv"
                type="text"
                v-model.trim="valueParams.sellerNote"
                size="md"
                placeholder="Ingrese el valor"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="OS" label-for="input-os" v-else>
              <b-form-input
                id="input-os"
                type="text"
                v-model.trim="valueParams.sequenceOS"
                size="md"
                placeholder="Ingrese el valor"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6" class="my-1"> </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="4" class="my-1">
            <label class="text-grey">Estado</label>
            <b-form-group>
              <b-form-select
                v-model="selectedState"
                size="md"
                :options="filteredStates"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="4" class="my-1">
            <label class="text-grey">Tienda</label>
            <combo-store
              v-model="selectedStore"
              v-bind:isComboSelected="false"
            ></combo-store>
          </b-col>
          <b-col cols="12" lg="4" class="my-1">
            <label class="text-grey">Proveedor</label>
            <template v-if="isProfileProvider">
              <b-form-group>
                <b-form-select
                  v-model="selectedProvider"
                  size="md"
                  :options="optionsProvider"
                >
                </b-form-select>
              </b-form-group>
            </template>
            <template v-else>
              <search-provider @rowSelectedProvider="setOptionSelected">
                <template slot="body">
                  <b-form-input
                    :disabled="true"
                    class="border-right-none"
                    v-model="selectedProviderUser"
                    size="md"
                    placeholder="Ingrese el usuario"
                  >
                  </b-form-input>
                </template>
              </search-provider>
            </template>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" class="my-1">
            <label class="text-grey">Tipos de fecha</label>
            <b-form-group>
              <b-form-select
                v-model="selectedFilterDate"
                size="md"
                :options="optionsDate"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="4" class="my-1">
            <label class="text-grey">Fecha inicio</label>
            <b-form-input type="date" v-model="startDate"></b-form-input>
          </b-col>
          <b-col lg="4" class="my-1">
            <label class="text-grey">Fecha fin</label>
            <b-form-input type="date" v-model="endDate"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="padding-ten-tb">
          <b-col cols="12" sm="12" md="12" lg="4" style="text-align: left">
            <b-button class="bg-grey-btn hidden-icon" @click="clearValues">
              <font-awesome-icon icon="broom" s /> LIMPIAR
            </b-button>
            <b-button
              @click="searchData"
              class="bg-orange-btn width-1000 padding-six-right"
            >
              <font-awesome-icon icon="search" /> BUSCAR
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="bg-white padding-five-all">
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <h5 class="color-orange">Resultados</h5>
          </b-col>
        </b-row>
        <!-- Main table element -->
        <b-table
          class="hidden-xs"
          show-empty
          small
          :busy="isBusy"
          striped
          :items="dataAdminOS"
          :fields="fields"
          :current-page="currentPage"
          :per-page="0"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(creationDate)="data">
            <span>{{ formatDate(data.item.creationDate) }} </span>
          </template>
          <template #cell(referenceDate)="data">
            <span>{{ formatDateV2(data.item.referenceDate) }} </span>
          </template>
          <template #cell(typeOs)="data">
            <span v-if="data.item.typeOs">{{ data.item.typeOs }} </span>
            <span v-else>
              REGULAR
            </span>
          </template>

          <template v-slot:cell(actions)="row">
            <b-card class="border-none padding-none text-center">
              <b-row>
                <b-col
                  class="padding-none margin-none"
                  cols="auto"
                  v-for="(option, index) in optionsAdminOs"
                  :key="index"
                >
                  <b-button
                    v-if="option.name === 'DetalleOS'"
                    size="sm"
                    @click="getDetails(row.item, $event.target)"
                    class="mr-1 btn-orange-tra bg-grey color-dark"
                    v-b-tooltip.hover
                    title="Ver detalle"
                    ><font-awesome-icon icon="eye" />
                  </b-button>

                  <b-button
                    v-if="option.name === 'TrackingOS'"
                    size="sm"
                    @click="trackingOS(row.item)"
                    class="mr-1 btn-orange-tra bg-grey color-dark"
                    v-b-tooltip.hover
                    title="Tracking"
                    ><font-awesome-icon icon="file-medical-alt" />
                  </b-button>

                  <b-button
                    v-if="option.name === 'ImpresionOS'"
                    :disabled="row.item.state == 'PENDIENTE_CREACION'"
                    size="sm"
                    @click="printOS(row.item, $event.target)"
                    class="mr-1 btn-orange-tra bg-grey color-dark"
                    v-b-tooltip.hover
                    title="Impresión"
                  >
                    <font-awesome-icon icon="print" />
                  </b-button>
                </b-col>
                 
                  <b-col v-if="validateBtn(row)" class="padding-none margin-none" cols="auto">
                    <b-button
                      :disabled="isEnableAsociation(row.item)"
                      size="sm"
                      @click="setValues(row.item, $event.target)"
                      class="mr-1 btn-orange-tra bg-grey color-dark"
                      v-b-tooltip.hover
                      v-b-modal.modal-options-vt
                      title="Asociar Os"
                      ><font-awesome-icon icon="plus" />
                    </b-button>
                  </b-col>
               

                <b-col v-else-if="showButton(row)" class="padding-none margin-none" cols="auto">
                  <b-button
                    :disabled="isEnableAsociation(row.item)"
                    size="sm"
                    @click="setValues(row.item, $event.target)"
                    v-b-modal.modal-options-vi
                    class="mr-1 btn-orange-tra bg-grey color-dark"
                    v-b-tooltip.hover
                    title="Asociar Os"
                    >
                     <font-awesome-icon icon="plus" />
                  </b-button>
                </b-col>

                <b-col class="padding-none margin-none" cols="auto">
                  <b-dropdown
                    id="dropdown-offset"
                    dropleft
                    dropup
                    offset="-125"
                    size="lg"
                    variant="color-dark"
                    toggle-class="text-decoration-none "
                    no-caret
                  >
                    <template #button-content>
                      <font-awesome-icon icon="ellipsis-v" />
                    </template>
                    <template v-if="row.item.state == 'INGRESADA'">
                      <b-dropdown-item-button
                        v-if="programacionPermiso"
                        v-b-modal.modal-programar
                        @click="setIdProgr(row.item, $event.target)"
                      >
                        <font-awesome-icon
                          icon="calendar-day"
                          style="color: #40a2e3"
                        />

                        Programar
                      </b-dropdown-item-button>
                      <li v-if="reprogramacionAntincipada">
                        <b-button
                          class="bg-tpr dropdown-item"
                          v-b-modal.modal-reprogramar-antic
                          @click="setDetailId(row.item, $event.target)"
                        >
                          <font-awesome-icon
                            icon="calendar-day"
                            style="color: #40a2e3"
                          />

                          Reprogramar Antic.
                        </b-button>
                      </li>
                    </template>
                    <template
                      v-if="
                        row.item.state == 'REALIZADA' &&
                          row.item.typeOs == 'VTEC' &&
                          row.item.idTechnicalReport
                      "
                    >
                      <b-dropdown-item-button
                        v-b-modal.modal-informe
                        @click="setIdInform(row.item, $event.target)"
                      >
                        <font-awesome-icon
                          icon="calendar-day"
                          style="color: #40a2e3"
                        />

                        Editar Informe
                      </b-dropdown-item-button>
                    </template>
                    <template
                      v-if="
                        row.item.state == 'REALIZADA' &&
                          row.item.typeOs == 'VINS' &&
                          row.item.idInspectionReport
                      "
                    >
                      <b-dropdown-item-button
                        v-b-modal.modal-informe-vins
                        @click="setIdInspectionReport(row.item, $event.target)"
                      >
                        <font-awesome-icon
                          icon="calendar-day"
                          style="color: #40a2e3"
                        />

                        Editar Informe
                      </b-dropdown-item-button>
                    </template>
                    <template
                      v-if="
                        row.item.state == 'REPROGRAMADA' ||
                          row.item.state == 'REALIZADA_PARCIAL'
                      "
                    >
                      <b-dropdown-item-button
                        v-if="programacionPermiso"
                        v-b-modal.modal-programar
                        @click="setIdProgr(row.item, $event.target)"
                      >
                        <font-awesome-icon
                          icon="calendar-day"
                          style="color: #40a2e3"
                        />

                        Programar
                      </b-dropdown-item-button>
                    </template>
                    <template v-if="row.item.state == 'COORDINADA' &&perfil!='PROVEEDOR'">
                      <li v-if="confirmacionOS">
                        <b-button
                          class="bg-tpr dropdown-item"
                          v-b-modal.modal-confirmar
                          @click="setDetailId(row.item, $event.target)"
                        >
                          <font-awesome-icon
                            icon="check-circle"
                            style="color: #3eb89b"
                          />
                          Confirmar
                        </b-button>
                      </li>
                      <li v-if="reprogramacionOS">
                        <b-button
                          class="bg-tpr dropdown-item"
                          v-b-modal.modal-reprogramar
                          @click="setDetailId(row.item, $event.target)"
                        >
                          <font-awesome-icon
                            icon="clock"
                            style="color: #ff8d24"
                          />
                          Reprogramar
                        </b-button>
                      </li>
                    </template>
                    <template
                      v-if="
                        row.item.state == 'PENDIENTE_CREACION' ||
                          row.item.state == 'PENDIENTE_REPROGRAMACION'
                      "
                    >
                      <b-dropdown-item-button
                        v-if="aprobacionPermiso"
                        v-b-modal.modal-aprobar
                        @click="setDetailId(row.item, $event.target)"
                      >
                        <font-awesome-icon
                          icon="check-circle"
                          style="color: #3eb89b"
                        />
                        Aprobar
                      </b-dropdown-item-button>
                    </template>
                    <template v-if="row.item.state == 'NO_REALIZADA'">
                      <li v-if="reprogramacionOS">
                        <b-button
                          class="bg-tpr dropdown-item"
                          v-b-modal.modal-reprogramar
                          @click="setDetailId(row.item, $event.target)"
                        >
                          <font-awesome-icon
                            icon="clock"
                            style="color: #ff8d24"
                          />
                          Reprogramar
                        </b-button>
                      </li>
                    </template>
                    <template v-if="row.item.state == 'REPROGRAMADA_ANTIC'">
                      <b-dropdown-item-button
                        v-if="programacionPermiso"
                        v-b-modal.modal-programar
                        @click="setIdProgr(row.item, $event.target)"
                      >
                        <font-awesome-icon
                          icon="calendar-day"
                          style="color: #40a2e3"
                        />

                        Programar
                      </b-dropdown-item-button>
                    </template>
                    <template
                      v-if="
                        row.item.state != 'ANULADA' &&
                          row.item.state != 'REALIZADA'
                      "
                    >
                      <b-dropdown-item-button
                        v-if="anulacionOS"
                        class="color-purple"
                        v-b-modal.modal-anular
                        @click="setDetailId(row.item, $event.target)"
                      >
                        <font-awesome-icon icon="trash" /> Anular
                      </b-dropdown-item-button>
                    </template>
                    <template
                      v-if="anulacionEspecial && row.item.state === 'REALIZADA'"
                    >
                      <b-dropdown-item-button
                        v-if="anulacionOS"
                        class="color-purple"
                        v-b-modal.modal-anular
                        @click="setDetailId(row.item, $event.target)"
                      >
                        <font-awesome-icon icon="trash" /> Anular
                      </b-dropdown-item-button>
                    </template>
                  </b-dropdown>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-table>
        <b-table
          class="show-xs"
          show-empty
          :busy="isBusy"
          striped
          stacked="sm"
          :items="dataAdminOS"
          :fields="fieldsTab"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          thead-class="hidden_header"
          responsive
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-card
              style="background: transparent"
              class="padding-none text-center"
            >
              <b-row>
                <b-col cols="10" class="text-sm-right">
                  <label class="color-orange" for="">N° OS </label>
                  <span class="color-orange">{{ row.item.sequence }} </span>
                </b-col>
                <b-col cols="2" style="text-align: right">
                  <b-button
                    style="
                      background: transparent;
                      color: #545b62;
                      border-color: transparent;
                    "
                    size="sm"
                    @click="row.toggleDetails"
                  >
                    <font-awesome-icon
                      :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </template>
          <template #row-details="row">
            <b-card style="background: transparent">
              <b-row>
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Estado</label>
                  <span>{{ row.item.state }} </span></b-col
                >
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Doc. Identidad</label>
                  <span>{{ row.item.identityDocument }} </span></b-col
                >
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Fecha estimada</label>
                  <span>{{ row.item.estimatedDate }} </span></b-col
                >
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Turno</label>
                  <span>{{ row.item.turn }} </span></b-col
                >
              </b-row>
              <b-row>
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Tienda</label>
                  <span>{{ row.item.storeDescription }} </span></b-col
                >
              </b-row>
              <b-row>
                <b-col
                  cols="auto"
                  v-for="(option, index) in optionsAdminOs"
                  :key="index"
                >
                  <b-button
                    v-if="option.name === 'DetalleOS'"
                    size="md"
                    @click="getDetails(row.item, $event.target)"
                    class="mr-1 btn-orange-tra bg-grey color-dark"
                    v-b-tooltip.hover
                    title="Ver detalle"
                    ><font-awesome-icon icon="eye" />
                  </b-button>

                  <b-button
                    v-if="option.name === 'TrackingOS'"
                    size="md"
                    @click="trackingOS(row.item)"
                    class="mr-1 btn-orange-tra bg-grey color-dark"
                    v-b-tooltip.hover
                    title="Tracking"
                    ><font-awesome-icon icon="file-medical-alt" />
                  </b-button>

                  <b-button
                    v-if="option.name === 'ImpresionOS'"
                    :disabled="row.item.state == 'PENDIENTE_CREACION'"
                    size="md"
                    @click="printOS(row.item, $event.target)"
                    class="mr-1 btn-orange-tra bg-grey color-dark"
                    v-b-tooltip.hover
                    title="Impresión"
                  >
                    <font-awesome-icon icon="print" />
                  </b-button>
                </b-col>
                <b-col cols="auto">
                  <b-dropdown
                    id="dropdown-offset"
                    dropleft
                    dropup
                    offset="-125"
                    size="lg"
                    variant="color-dark"
                    toggle-class="text-decoration-none "
                    no-caret
                  >
                    <template #button-content>
                      <font-awesome-icon icon="ellipsis-v" />
                    </template>
                    <template v-if="row.item.state == 'INGRESADA'">
                      <b-dropdown-item-button
                        v-b-modal.modal-programar
                        @click="setIdProgr(row.item, $event.target)"
                      >
                        <font-awesome-icon
                          icon="calendar-day"
                          style="color: #40a2e3"
                        />

                        Programar
                      </b-dropdown-item-button>
                      <li v-if="reprogramacionAntincipada">
                        <b-button
                          class="bg-tpr dropdown-item"
                          v-b-modal.modal-reprogramar-antic
                          @click="setDetailId(row.item, $event.target)"
                        >
                          <font-awesome-icon
                            icon="calendar-day"
                            style="color: #40a2e3"
                          />

                          Reprogramar Antic.
                        </b-button>
                      </li>
                    </template>
                    <template v-if="row.item.state == 'INGRESADA'">
                      <b-dropdown-item-button
                        v-b-modal.modal-programar
                        @click="setIdProgr(row.item, $event.target)"
                      >
                        <font-awesome-icon
                          icon="calendar-day"
                          style="color: #40a2e3"
                        />

                        Editar Informe
                      </b-dropdown-item-button>
                    </template>
                    <template
                      v-if="
                        row.item.state == 'REPROGRAMADA' ||
                          row.item.state == 'REALIZADA_PARCIAL'
                      "
                    >
                      <b-dropdown-item-button
                        v-if="programacionPermiso"
                        v-b-modal.modal-programar
                        @click="setIdProgr(row.item, $event.target)"
                      >
                        <font-awesome-icon
                          icon="calendar-day"
                          style="color: #40a2e3"
                        />

                        Programar
                      </b-dropdown-item-button>
                    </template>
                    <template v-if="row.item.state == 'COORDINADA' &&perfil!='PROVEEDOR'">
                      <li v-if="confirmacionOS">
                        <b-button
                          class="bg-tpr dropdown-item"
                          v-b-modal.modal-confirmar
                          @click="setDetailId(row.item, $event.target)"
                        >
                          <font-awesome-icon
                            icon="check-circle"
                            style="color: #3eb89b"
                          />
                          Confirmar
                        </b-button>
                      </li>
                      <li v-if="reprogramacionOS">
                        <b-button
                          class="bg-tpr dropdown-item"
                          v-b-modal.modal-reprogramar
                          @click="setDetailId(row.item, $event.target)"
                        >
                          <font-awesome-icon
                            icon="clock"
                            style="color: #ff8d24"
                          />
                          Reprogramar
                        </b-button>
                      </li>
                    </template>
                    <template
                      v-if="
                        row.item.state == 'PENDIENTE_CREACION' ||
                          row.item.state == 'PENDIENTE_REPROGRAMACION'
                      "
                    >
                      <b-dropdown-item-button
                        v-if="aprobacionPermiso"
                        v-b-modal.modal-aprobar
                        @click="setDetailId(row.item, $event.target)"
                      >
                        <font-awesome-icon
                          icon="check-circle"
                          style="color: #3eb89b"
                        />
                        Aprobar
                      </b-dropdown-item-button>
                    </template>
                    <template v-if="row.item.state == 'NO_REALIZADA'">
                      <li v-if="reprogramacionOS">
                        <b-button
                          class="bg-tpr dropdown-item"
                          v-b-modal.modal-reprogramar
                          @click="setDetailId(row.item, $event.target)"
                        >
                          <font-awesome-icon
                            icon="clock"
                            style="color: #ff8d24"
                          />
                          Reprogramar
                        </b-button>
                      </li>
                    </template>
                    <template v-if="row.item.state == 'REPROGRAMADA_ANTIC'">
                      <b-dropdown-item-button
                        v-if="programacionPermiso"
                        v-b-modal.modal-programar
                        @click="setIdProgr(row.item, $event.target)"
                      >
                        <font-awesome-icon
                          icon="calendar-day"
                          style="color: #40a2e3"
                        />

                        Programar
                      </b-dropdown-item-button>
                    </template>
                    <template v-if="row.item.state != 'ANULADA'">
                      <b-dropdown-item-button
                        v-if="anulacionOS"
                        class="color-purple"
                        v-b-modal.modal-anular
                        @click="setDetailId(row.item, $event.target)"
                      >
                        <font-awesome-icon icon="trash" /> Anular
                      </b-dropdown-item-button>
                    </template>
                  </b-dropdown>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rowsTable"
          :per-page="perPage"
          pills
          limit="4"
          first-number
          hide-goto-end-buttons
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-container>
    </div>
    <section id="printSection2" v-if="isPrinting">
      
      <impresion-informe :idTechInform="idTechInform"> </impresion-informe>
    </section>
    <section id="printSectionVI" v-if="isPrintingVI">
      
      <impresion-informe-vi :idInspectionReport="idInspectionReport"> </impresion-informe-vi>
    </section>
    <div>
      <b-modal
        @hidden="onHiddenModal"
        header-text-variant="modal-anular"
        id="modal-anular"
        centered
        hide-footer
        title="Anulación"
      >
        <anular-os :detailId="detailId" :identityDocument="identityDocument" :beetrackRouteId="beetrackRouteId" @setResponse="setValuesResponse">
        </anular-os>
      </b-modal>

      <b-modal
        @hidden="onHiddenModal"
        header-text-variant="modal-aprobar"
        id="modal-aprobar"
        centered
        hide-footer
        title="Aprobación"
      >
        <aprobar-os
          :detailId="detailId"
          @setResponse="setValuesResponse"
        ></aprobar-os>
      </b-modal>
      <b-modal
        @hidden="onHiddenModal"
        header-text-variant="modal-confirmar"
        id="modal-confirmar"
        centered
        hide-footer
        title="Confirmación"
      >
        <confirmar-os
          :detailId="detailId"
          @setResponse="setValuesResponse"
        ></confirmar-os>
      </b-modal>
      <b-modal
        @hidden="onHiddenModal"
        header-text-variant="modal-reprogramar"
        id="modal-reprogramar"
        centered
        hide-footer
        title="Reprogramación"
      >
        <reprogramar-os :detailId="detailId" @setResponse="setValuesResponse">
        </reprogramar-os>
      </b-modal>
      <b-modal
        @hidden="onHiddenModal"
        header-text-variant="modal-programar"
        id="modal-programar"
        centered
        hide-footer
        title="Programación"
      >
        <programar-os
          :valuesProg="valuesProg"
          @setResponse="setValuesResponse"
        ></programar-os>
      </b-modal>
      <b-modal
        header-text-variant="modal-informe"
        id="modal-informe"
        centered
        hide-footer
        size="lg"
        title="Informe Técnico"
        @hidden="callMethod"
      >
        <informe-tecnico :idTechInform="idTechInform"> 
          <template slot="button-print">
            <b-button @click="printInform" class="btn-orange">
              <font-awesome-icon icon="print" /> IMPRIMIR
            </b-button>
          </template>

        </informe-tecnico>
      </b-modal>
      <b-modal
        header-text-variant="modal-informe-vins"
        id="modal-informe-vins"
        centered
        hide-footer
        size="lg"
        title="Informe Técnico"
      >
        <report-tech-vi :idInspectionReport="idInspectionReport">
          <template slot="button-print-vi">
            <b-button @click="printInformVi" class="btn-orange">
              <font-awesome-icon icon="print" /> IMPRIMIR
            </b-button>
          </template>
        </report-tech-vi>
      </b-modal>
      <b-modal id="modal-options-vi" hide-footer >
        <b-container fluid>
          <p>Elige el tipo de OS:</p>
          <b-button
            @click="redirectSelletNote()"
            block
            class="section__button_rounded"
          >
            Nota de Venta
          </b-button>
          <b-button
            @click="redirectToCreateOrderVi()"
            block
            class="section__button_rounded"
          >
            Manual
          </b-button>
        </b-container>
      </b-modal>
      <b-modal id="modal-options-vt" hide-footer >
        <b-container fluid>
          <p>Elige el tipo de OS:</p>
          <b-button
            @click="redirectSelletNoteVt()"
            block
            class="section__button_rounded"
          >
            Nota de Venta
          </b-button>
          <b-button
            @click="redirectToCreateOrderVt()"
            block
            class="section__button_rounded"
          >
            Manual
          </b-button>
        </b-container>
      </b-modal>
      <b-modal
        @hidden="onHiddenModal"
        header-text-variant="modal-reprogramar-antic"
        id="modal-reprogramar-antic"
        centered
        hide-footer
        title="Reprogramación Antic."
      >
        <reprogramar-antic-os
          :detailId="detailId"
          @setResponse="setValuesResponse"
        >
        </reprogramar-antic-os>
      </b-modal>
      <template>
        <b-modal
          v-model="propertiesModal.show"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
          hide-header
          centered
          ok-only
          content-class="text-center"
        >
          <p>{{ propertiesModal.message }}</p>
          <template v-if="!propertiesModal.hasError">
            <b-button class="bg-orange" @click="reloadData"> OK </b-button>
          </template>
          <template v-else>
            <b-button class="bg-orange" @click="resetPropertiesModal">
              OK
            </b-button>
          </template>
        </b-modal>
      </template>
    </div>
   
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import {createLogs} from '../../assets/js/common'
import ProgramarOs from "../../components/AdminOS/ProgramarOs";
import AprobarOs from "../../components/AdminOS/AprobarOs.vue";
import AnularOs from "../../components/AdminOS/AnularOs.vue";
import ConfirmarOs from "../../components/AdminOS/ConfirmarOs.vue";
import ReprogramarOs from "../../components/AdminOS/ReprogramarOs.vue";
import ReprogramarAnticOs from "../../components/AdminOS/ReprogramarAnticOs.vue";
import SearchProvider from "../../components/AdminOS/SearchProvider";
import InformeTecnico from "../../components/VisitaTecnica/InformeTecnico.vue";
import ReportTechVi from "../../components/VisitaInspeccion/ReportTechVi.vue";
import store from "@/store";
import ComboStore from "../../components/ComboStore.vue";

import moment from "moment";
import ImpresionInforme from '../Proyectos/ImpresionInforme.vue';
import ImpresionInformeVi from '../../components/VisitaInspeccion/ImpresionInformeVi';

export default {
  name: "AdministracionOs",
  data() {
    return {
      isPrintingVI:false,
      isPrinting:false,
      itemsData:[],
      dataSelected:"",
      propertiesModal: { show: false, message: "", hasError: false },
      detailId: null,
      fields: [
        {
          key: "sequence",
          label: "N° OS",
          sortDirection: "desc",
        },
        {
          key: "state",
          label: "Estado",
          sortable: true,
        },
        {
          key: "identityDocument",
          label: "Doc. Identidad",
        },
        { key: "creationDate", label: "F. Creación" },
        { key: "referenceDate", label: "F. Estimada" },

        { key: "turn", label: "Turno", sortable: true },
        { key: "user", label: "Proveedor", sortable: true },
        { key: "storeDescription", label: "Tienda" },
        { key: "origin", label: "Origen" },
        { key: "typeOs", label: "Tipo" },
        { key: "actions", label: "" },
      ],
      fieldsTab: [{ key: "actions", label: "" }],
      optionsTypeDoc: [
        { value: "a", text: "Doc. Identidad" },
        { value: "a", text: "RUC" },
        { value: "b", text: "Nota de venta" },
        { value: "c", text: "N° OS" },
      ],
      optionsTypeOs: [
        { value: null, text: "TODOS" },
        { value: "VTEC", text: "VISITA TÉCNICA" },
        { value: "VINS", text: "VISITA INSPECCIÓN" },
      ],
      selectedTypeOs: null,
      selectedValue: "a",
      optionsStates: [
        { value: "TODOS", text: "TODOS" },
        { value: "INGRESADA", text: "INGRESADA" },
        { value: "COORDINADA", text: "COORDINADA" },
        { value: "REALIZADA", text: "REALIZADA" },
        { value: "ANULADA", text: "ANULADA" },
        { value: "REPROGRAMADA", text: "REPROGRAMADA" },
        { value: "PENDIENTE_CREACION", text: "PENDIENTE_CREACION" },
        { value: "NO_REALIZADA", text: "NO_REALIZADA" },
        { value: "PENDIENTE_PAGO", text: "PENDIENTE_PAGO" },
        { value: "PENDIENTE_REPROGRAMACION", text: "PENDIENTE_REPROGRAMACION" },
        { value: "REPROGRAMADA_ANTIC", text: "REPROGRAMADA_ANTIC" },
        { value: "REALIZADA_PARCIAL", text: "REALIZADA_PARCIAL" },
      ],
      selectedState: "TODOS",
      optionsDate: [
        { value: "a", text: "Fecha de creación" },
        { value: "b", text: "Fecha estimada" },
      ],
      selectedFilterDate: "a",
      selectedStore: 0,
      valueParams: {
        dni: null,
        sellerNote: "",
        sequenceOS: "",
        typeOs: "",
      },
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      countTotal: 500,
      currentPage: 1,
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      valuesForm: { detailId: "" },
      valuesProg: { detailId: "", providerId: "" },
      idTechInform: "",
      idTechInformVi: null,
      idInspectionReport: null,
      optionsProvider: [],
      selectedProvider: 0,
      selectedProviderUser: null,
      countRecords: 20,
      beetrackRouteId:null,
      identityDocument:null
    };
  },
  components: {
    ProgramarOs,
    AprobarOs,
    AnularOs,
    ConfirmarOs,
    ReprogramarOs,
    ReprogramarAnticOs,
    SearchProvider,
    ComboStore,
    InformeTecnico,
    ReportTechVi,
    ImpresionInforme,
    ImpresionInformeVi
  },
  computed: {
    rowsTable() {
      if (this.currentPage == 1 && this.itemsData.length < 10) return 10;
      return this.countRecords;
    },
    ...mapState({
      dataAdminOS: (state) => state.dataAdminOS,
    }),
    ...mapState("module", [
      "perfil",
      "idProvider",
      "username",
      "store",
      "options",
      "token"
    ]),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },

    isProfileProvider() {
      let up = this.perfil.toUpperCase();
      if (up === "PROVEEDOR") return true;
      return false;
    },
    aprobacionPermiso() {
      return this.options.some((m) => m.name === "AprobacionOS");
    },
    programacionPermiso() {
      return this.options.some((m) => m.name === "ProgramaciónOS");
    },
    reprogramacionAntincipada() {
      return this.options.some((m) => m.id == 22);
    },
    reprogramacionOS() {
      return this.options.some((m) => m.name === "ReprogramaciónOS");
    },
    anulacionEspecial() {
      return this.options.some((m) => m.id === 29);
    },
    confirmacionOS() {
      return this.options.some((m) => m.name === "ConfirmaciónOS");
    },
    anulacionOS() {
      return this.options.some((m) => m.name === "AnulaciónOS");
    },
    optionsAdminOs() {
      return this.options.filter((entry) => {
        return (
          entry.name == "TrackingOS" ||
          entry.name == "ImpresionOS" ||
          entry.name == "DetalleOS"
        );
      });
    },
    exportarPermiso() {
      let reporteTienda = this.options.some((m) => m.id == 26);
      let reporteProveedor = this.options.some((m) => m.id == 27);
      if (reporteTienda || reporteProveedor) return true;
      return false;
    },
    filteredStates() {
      if (this.perfil === "PROVEEDOR") {
        const filter = this.optionsStates.filter(
          (o) => o.value != "PENDIENTE_CREACION" && o.value != "PENDIENTE_PAGO"
        );
        return filter;
      } else return this.optionsStates;
    },
  },
  watch: {
    currentPage: {
      handler: function() {
        this.searchData()
          .then((res) => {
            if (res.length < 10) return;
            this.countRecords = this.countRecords + 20;

            console.log(this.countRecords, res);
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
  },
  beforeRouteEnter(to, from, next) {
    let menu = store.getters["module/optionsMenu"];
    let authProvider = menu.some(
      (s) => s.name.toUpperCase() == to.name.toUpperCase()
    );
    if (!authProvider) next({ name: "BlockedPage" });
    else next();
  },
  created() {
    this.getProviders();

    ///this.selectedStore = this.store[0].codigo;
  },

  methods: {
    callMethod(){
      console.log('callling')
      this.isPrinting=!this.isPrinting
    },
    printInform(){
      
      window.print();
    },
    printInformVi(){
      window.print();
    },
    validateBtn(row){
      let up = this.perfil.toUpperCase();
      if(row.item.typeOs == 'VTEC'&&row.item.typeOs!=null&&up!='PROVEEDOR') return true
       else return false
      
    },
    showButton(row){
      let up = this.perfil.toUpperCase();
      if(row.item.state=='REALIZADA' &&row.item.typeOs ==null&&row.item.idInspectionReport==null&&up!='PROVEEDOR') return true
       else return false
    },
    setValues(item){

      this.dataSelected=item;
    },
    isEnableAsociation(item) {
      if (
        item.typeOs == "VTEC" &&
        item.idTechnicalReport != null &&
        item.state == "REALIZADA"
      ) {
        return false;
      } else if (item.state == "REALIZADA") return false;
      else return true;
    },
    onHiddenModal() {
      if (this.detailId) this.detailId = null;
      if (this.valuesProg.detailId) this.valuesProg.detailId = null;
      if (this.valuesProg.providerId) this.valuesProg.providerId = null;
    },
    async reloadData() {
      this.resetPropertiesModal();
      await this.searchData();
    },
    resetPropertiesModal() {
      this.propertiesModal.show = false;
      this.propertiesModal.message = "";
      this.propertiesModal.hasError = false;
    },
    setValuesResponse(selected) {
      this.propertiesModal.show = selected.show;
      this.propertiesModal.message = selected.message;
      this.propertiesModal.hasError = selected.hasError;
    },
    formatDateV2(val) {
      return moment(val, "DD/MM/YYYY").format("DD/MM/YYYY");
    },
    formatDate(val) {
      return moment(val).format("DD/MM/YYYY");
    },
    setOptionSelected(selected) {
     
        this.selectedProvider = selected;
        this.selectedProviderUser = selected;
      
    },

    setDetailId(item) {
      this.detailId = item.detailId;
      if(item.beetrackRouteId){
        this.beetrackRouteId=item.beetrackRouteId
        this.identityDocument=item.identityDocument
      }
      
    },
    clearValues() {
      this.valueParams.dni = "";
      this.valueParams.sellerNote = "";
      this.valueParams.sequenceOS = "";
      this.selectedProvider = 0;
      this.selectedStore = 0;
      this.startDate = "";
      this.endDate = "";
      this.selectedProviderUser = null;
    },
    async getFilteredProviders() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ENDPOINT_PROVIDERS_CORE_BASE +
            "/providers/" +
            this.idProvider
        );
        let arr = [];
        arr.push(response.data);

        const data = arr.map((row) => {
          return {
            value: row.id,
            text: row.user,
          };
        });
        this.optionsProvider = data;
        this.selectedProvider = this.idProvider;
      } catch (error) {
        console.log(error);
      }
    },
    async getProviders() {
      if (this.isProfileProvider) {
        this.selectedProvider = this.idProvider;
        this.getFilteredProviders();
      } /*else {
        this.getProvidersList();
      } */
    },
    async getProvidersList() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ENDPOINT_PROVIDERS_CORE_BASE +
            "/providers?limit=1000&state=ACTIVE&page=1&pagination=true"
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.user,
          };
        });
        var sortedData= data.sort((a,b) => a.text.localeCompare(b.text))
        this.optionsProvider = sortedData;
      } catch (error) {
        console.log(error);
      } finally {
        //this.$store.commit("SET_LOADING", false)
      }
    },
    setIdProgr(item) {
      this.valuesProg.detailId = item.detailId;
      this.valuesProg.providerId = item.providerId;
      this.valuesProg.state = item.state;
    },
    setIdInform(item) {
      this.idTechInform = item.idTechnicalReport;
      this.isPrinting=true;
    },

    
    setIdInspectionReport(item) {
    
      this.idInspectionReport = item.idInspectionReport;
      this.isPrintingVI=true;
      console.log(this.idInspectionReport);
    },
    clearParamsVal() {
      this.valueParams.dni = "";
      this.valueParams.sellerNote = "";
      this.valueParams.sequenceOS = "";
    },
    printOS(item) {
      let index = item.sequence.indexOf("-");
      const nuevaStr = item.sequence.substring(0, index);
      this.$router.push({ path: `/print-os/${nuevaStr}` });
    },
    getDetails(item) {
      this.$router.push({ path: `/details-os/${item.sequence}` });
    },
    redirectToCreateOrder(item) {
      this.$router.push({
        path: `/crear-os/manual/${item.detailId}/tipo/VTEC`,
      });
    },
    redirectToCreateOrderVi() {
      this.$router.push({ path: `/crear-os/manual/${this.dataSelected.detailId}/tipo/VI` });
    },
    redirectToCreateOrderVt() {
      this.$router.push({ path: `/crear-os/manual/${this.dataSelected.detailId}/tipo/VTEC` });
    },
    redirectSelletNote() {
      this.$router.push({ path: `/crear-os/nota-venta/${this.dataSelected.detailId}/tipo/VI` });
    },
    redirectSelletNoteVt(){
      this.$router.push({ path: `/crear-os/nota-venta/${this.dataSelected.detailId}/tipo/VTEC` });
    },
    trackingOS(item) {
      this.$router.push({ path: `/tracking/${item.sequence}` });
    },
    async searchData() {
      
      this.isBusy = true;
      //let valStore = this.selectedStore>0 ? this.selectedStore : "";
      let valStore =
        this.selectedStore && this.selectedStore > 0
          ? "&store=" + this.selectedStore
          : "";
      let startDate =
        this.selectedFilterDate == "a"
          ? "&startCreationDate=" + this.startDate
          : "&startReferenceDate=" + this.startDate;
      let endDate =
        this.selectedFilterDate == "a"
          ? "&endCreationDate=" + this.endDate
          : "&endReferenceDate=" + this.endDate;
      let provId = this.selectedProvider > 0 ? this.selectedProvider : "";
      let docId = this.valueParams.dni
        ? "identityDocument=" + this.valueParams.dni
        : "";
      let filterTypeOs = this.selectedTypeOs
        ? "&typeOs=" + this.selectedTypeOs
        : "";
      try {
        let response = await axios.get(
          process.env.VUE_APP_RECORDS_BUSINESS_BASE +
            "/records?" +
            docId +
            "&state=" +
            this.selectedState +
            valStore +
            "&sellerNote=" +
            this.valueParams.sellerNote +
            "&sequence=" +
            this.valueParams.sequenceOS +
            "&provider=" +
            provId +
            startDate +
            endDate +
            filterTypeOs +
            "&page=" +
            this.currentPage +
            "&limit=" +
            this.perPage,
            {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
        
        createLogs(response.config.url,this.username,response.config.method,this.$router.history.current.path);
        console.log(response.data);
        const filteredOrder = this.filterOrderServices(response.data);
        this.itemsData = response.data;
        this.$store.commit("SET_DATA_ADMINOS", filteredOrder);
        return response.data;
        //this.detailsOS = response.data;
      } catch (error) {
        if (!error.response) {
          // alert("error");
        }

        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    filterOrderServices(order) {
      if (this.perfil === "PROVEEDOR") {
        const filteredArr = order.filter(
          (o) =>
            o.state != "PENDIENTE_CREACION" &&
            o.state != "PENDIENTE_PAGO" &&
            o.state != "PENDIENTE_REPROGRAMACION"&&
            o.state != "ANULADA"
        );
        return filteredArr;
      }
      return order;
    },
  },
};
</script>
<style scoped>
@media screen {
  #printSection2 {
      display: none;
  }
  #printSectionVI {
      display: none;
  }
}
@media print {
  ::v-deep .b-table thead {
  color: black !important;
  font-weight: 500 !important;
}
::v-deep .b-table thead th {
  font-weight: 500 !important;
}
  body * {
    visibility:hidden;
  }
  #printSection2, #printSection2 * {
    visibility:visible;
  }
  #printSection2 {
    position:absolute;
    left:0;
    top:0;
  }
   #printSectionVI, #printSectionVI * {
    visibility:visible;
  }
  #printSectionVI {
    
    position:absolute;
    left:0;
    top:0;
  }
  
}
::v-deep .card-body {
  padding: 0;
}
::v-deep .text-modal-aprobar h5 {
  color: #ff7a00;
}
::v-deep .text-modal-reprogramar h5 {
  color: #ff7a00;
}
::v-deep .text-modal-confirmar h5 {
  color: #ff7a00;
}
::v-deep .text-modal-aprobar h5 {
  color: #ff7a00;
}
::v-deep .text-modal-anular h5 {
  color: #e73860;
}
.bg-grey-btn {
  background-color: #676767;
  border-radius: 20px;
}
.bg-grey {
  background-color: #ececec;
  border-color: transparent;
}
::v-deep .btn-color-dark {
  color: #bbbbbb;
}
.color-dark {
  color: #bbbbbb;
}

.padding-two-top {
  padding-top: 2.5%;
}
.btn-orange-tra {
  border-radius: 50%;
}
.form-control {
  border: none;
  border-bottom: 1px solid #ced4da;
  padding: 5px 10px;
  outline: none;
  border-radius: 0;
}
::v-deep.color-purple .dropdown-item {
  color: #e73860 !important;
}

::v-deep .page-item.active .page-link {
  background: #ff7a00;
  color: white;
  border-color: transparent;
}
::v-deep label {
  margin-bottom: 0;
  color: #676767;
  font-size: 15px;
  letter-spacing: 0;
}
::v-deep .page-item.disabled .page-link {
  background: transparent !important;
  border-color: transparent !important;
  color: #ff7a00;
}
::v-deep .page-link {
  color: #676767;
  border-color: transparent;
  font-weight: bold;
  background: transparent;
}

::v-deep #input-group-3__BV_label_ {
  color: #676767;
  font-size: 15px;
  letter-spacing: 0px;
  display: block;
  margin-bottom: 0;
}
.color-orange {
  color: #ff7a00;
}
.padding-six-right {
  margin-left: 20px;
}

.padding-ten-lr {
  padding: 10px;
  padding-left: 35px !important;
}

.color-gray {
  color: #676767;
  font-weight: bold;
}
.show-xs {
  display: none;
}
.btn-transparent {
  background: transparent !important;
  border-color: transparent !important;
}
::v-deep .b-table thead {
  background-color: transparent !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
::v-deep .table tr:first-child td {
  border-top: 1px solid transparent !important;
}
::v-deep .b-table thead th {
  font-weight: 700 !important;
  border: none !important;
  font-size: 11pt;
}
::v-deep .table td {
  color: black;
  font-size: 11pt;
}
::v-deep .table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}

@media (max-width: 645px) {
  .card {
    border-color: transparent !important;
  }
  .show-xs {
    visibility: visible;
  }
  .hidden-xs {
    display: none;
  }
  .padding-five-lr {
    padding-left: 0 !important;
    padding-right: 0;
  }
  .text-right-md {
    text-align: left !important;
    padding-top: 10px;
  }
}
.text-right-md {
  text-align: right;
}

#modal-informe-vins___BV_modal_header_{
    visibility: hidden !important;
  }
</style>
